import styled from 'styled-components'
import {
  ColorProps,
  color,
  FontSizeProps,
  FontWeightProps,
  fontSize,
  fontWeight,
  LayoutProps,
  layout,
  SpaceProps,
  space,
} from 'styled-system'

import { filterStyledSystemProps } from '@/helpers/styled-props'

interface LinkWrapperProps extends SpaceProps, FontWeightProps, LayoutProps, ColorProps, FontSizeProps {
  $underline?: boolean
}

export const LinkWrapper = styled.div.withConfig({
  shouldForwardProp: filterStyledSystemProps(),
})<LinkWrapperProps>`
  color: ${({ theme, $underline }) => ($underline ? theme.colors.violet : theme.colors.grey)};
  text-decoration: ${({ $underline }) => ($underline ? 'underline' : 'none')};
  cursor: pointer;

  &:hover {
    color: ${({ theme }) => theme.colors.paragraph};
  }

  ${fontWeight}
  ${fontSize}
  ${space}
  ${layout}
  ${color}
`
